// PGCET MCA Mock 2 — Mathematics (questions 1–30)
const pgcetmcaMathematics = [
  {
    id: 1,
    question: "The ratio in which the y-axis divides the line segment joining the points (5, −6) and (−1, −4) is",
    options: ["A. 1 : 5", "B. 5 : 1", "C. 6 : 1", "D. 1 : 6"],
    answer: "B"
  },
  {
    id: 2,
    question: "The acute angle between the lines y = (2 − √3)x + 5 and y = (2 + √3)x − 7 is",
    options: ["A. 30°", "B. 45°", "C. 90°", "D. 60°"],
    answer: "D"
  },
  {
    id: 3,
    question: "The centre and radius of the circle 2x² + 2y² − 8x + 12y − 6 = 0 are respectively",
    options: ["A. (2, −3) and 4", "B. (−2, 3) and 4", "C. (2, −3) and √7", "D. (4, −6) and √55"],
    answer: "A"
  },
  {
    id: 4,
    question: "The points on the parabola y² = 8x whose distance from the focus is 10 units are",
    options: ["A. (10, ±4√5)", "B. (6, ±4√3)", "C. (8, ±8)", "D. (12, ±4√6)"],
    answer: "C"
  },
  {
    id: 5,
    question: "If the length of the latus rectum of an ellipse is equal to half the length of its major axis, then the eccentricity of the ellipse is",
    options: ["A. 1/√2", "B. 1/2", "C. √3/2", "D. 1/√3"],
    answer: "A"
  },
  {
    id: 6,
    question: "The equation of the hyperbola whose foci are (±5, 0) and whose transverse axis has length 6 is",
    options: ["A. x²/16 − y²/9 = 1", "B. x²/9 − y²/25 = 1", "C. x²/9 − y²/16 = 1", "D. x²/25 − y²/16 = 1"],
    answer: "C"
  },
  {
    id: 7,
    question: "If tan θ = 3/4 and θ lies in the third quadrant, then sin θ + cos θ equals",
    options: ["A. 7/5", "B. 1/5", "C. −1/5", "D. −7/5"],
    answer: "D"
  },
  {
    id: 8,
    question: "The value of tan 75° + cot 75° is",
    options: ["A. 2√3", "B. 4", "C. 2", "D. 2 + √3"],
    answer: "B"
  },
  {
    id: 9,
    question: "If A + B = π/4, then the value of (1 + tan A)(1 + tan B) is",
    options: ["A. 1", "B. 0", "C. 2", "D. 4"],
    answer: "C"
  },
  {
    id: 10,
    question: "The number of solutions of the equation sin 2x = cos x in the interval [0, 2π] is",
    options: ["A. 4", "B. 2", "C. 3", "D. 6"],
    answer: "A"
  },
  {
    id: 11,
    question: "The sides of a triangle are 7 cm, 5 cm and 3 cm. The largest angle of the triangle is",
    options: ["A. 150°", "B. 90°", "C. 135°", "D. 120°"],
    answer: "D"
  },
  {
    id: 12,
    question: "The value of x satisfying tan⁻¹(2x) + tan⁻¹(3x) = π/4 is",
    options: ["A. −1", "B. 1/6", "C. 1/6 and −1", "D. 1/3"],
    answer: "B"
  },
  {
    id: 13,
    question: "A number is chosen at random from the integers 1 to 30. The probability that it is a multiple of 3 or of 5 is",
    options: ["A. 7/15", "B. 8/15", "C. 1/2", "D. 2/5"],
    answer: "A"
  },
  {
    id: 14,
    question: "Two fair dice are thrown. Given that the sum of the numbers shown is 8, the probability that one of the dice shows a 3 is",
    options: ["A. 1/18", "B. 1/5", "C. 2/5", "D. 1/3"],
    answer: "C"
  },
  {
    id: 15,
    question: "Bag I contains 3 white and 2 black balls; bag II contains 2 white and 4 black balls. A fair coin is tossed: on a head a ball is drawn from bag I, otherwise from bag II. If the ball drawn is white, the probability that it came from bag I is",
    options: ["A. 3/5", "B. 5/14", "C. 9/19", "D. 9/14"],
    answer: "D"
  },
  {
    id: 16,
    question: "A problem is given to three students whose chances of solving it independently are 1/2, 1/3 and 1/4. The probability that the problem is solved is",
    options: ["A. 1/24", "B. 3/4", "C. 1/4", "D. 23/24"],
    answer: "B"
  },
  {
    id: 17,
    question: "The probability that a leap year selected at random contains 53 Sundays is",
    options: ["A. 1/7", "B. 53/366", "C. 2/7", "D. 3/7"],
    answer: "C"
  },
  {
    id: 18,
    question: "The mean marks of 30 students of section A is 60 and the mean marks of 20 students of section B is 70. The mean marks of all 50 students is",
    options: ["A. 64", "B. 65", "C. 66", "D. 62"],
    answer: "A"
  },
  {
    id: 19,
    question: "The standard deviation of the observations 3, 7, 9, 11, 15 is",
    options: ["A. 16", "B. 2√2", "C. 8", "D. 4"],
    answer: "D"
  },
  {
    id: 20,
    question: "The two regression lines of a bivariate distribution are 3x + 2y = 26 and 6x + y = 31. The mean values (x̄, ȳ) are",
    options: ["A. (7, 4)", "B. (4, 7)", "C. (3, 8.5)", "D. (5, 5.5)"],
    answer: "B"
  },
  {
    id: 21,
    question: "If the regression coefficients of a bivariate distribution are b_yx = 0.8 and b_xy = 0.2, then the coefficient of correlation is",
    options: ["A. 0.4", "B. 0.16", "C. 0.5", "D. 1.0"],
    answer: "A"
  },
  {
    id: 22,
    question: "The value of lim (x → 0) of (sin 5x − sin 3x)/sin x is",
    options: ["A. 8", "B. 0", "C. 2", "D. 15"],
    answer: "C"
  },
  {
    id: 23,
    question: "The function f(x) = kx + 1 for x ≤ 2 and f(x) = 3x − 1 for x > 2 is continuous at x = 2. The value of k is",
    options: ["A. 1", "B. 2", "C. 3", "D. 5/2"],
    answer: "B"
  },
  {
    id: 24,
    question: "If y = xˣ (x > 0), then the value of dy/dx at x = e is",
    options: ["A. eᵉ", "B. eᵉ⁺¹", "C. 1 + e", "D. 2eᵉ"],
    answer: "D"
  },
  {
    id: 25,
    question: "The maximum value of the function f(x) = x e⁻ˣ, x ∈ R, is",
    options: ["A. 1/e", "B. e", "C. 1", "D. 2/e²"],
    answer: "A"
  },
  {
    id: 26,
    question: "∫ eˣ(1 + x) / cos²(x eˣ) dx equals (C is the constant of integration)",
    options: ["A. sec(x eˣ) + C", "B. −cot(x eˣ) + C", "C. tan(eˣ) + C", "D. tan(x eˣ) + C"],
    answer: "D"
  },
  {
    id: 27,
    question: "The value of the integral ∫ (x⁵ + x³ cos x + 2) dx from −1 to 1 is",
    options: ["A. 0", "B. 2", "C. 4", "D. 2 + 2 cos 1"],
    answer: "C"
  },
  {
    id: 28,
    question: "If |a| = 3, |b| = 4 and |a + b| = 5 for vectors a and b, then |a − b| equals",
    options: ["A. 1", "B. 5", "C. 7", "D. √7"],
    answer: "B"
  },
  {
    id: 29,
    question: "A unit vector perpendicular to both the vectors i + j and j + k is",
    options: ["A. ±(i − j + k)/√3", "B. ±(i + j + k)/√3", "C. ±(i − j − k)/√3", "D. ±(i + j − k)/√3"],
    answer: "A"
  },
  {
    id: 30,
    question: "If a · b = √3 and |a × b| = 1 for two vectors a and b, then the angle between a and b is",
    options: ["A. π/3", "B. π/4", "C. π/6", "D. 2π/3"],
    answer: "C"
  }
];

export default pgcetmcaMathematics;
